export default __webpack_public_path__ + "/strength-of-the-titans-by-kevin-macleod-from-filmmusic-io.mp3";